import {OnFailure, OnSuccess, OnSuccessData} from "../../../store/action/actionHelpers";
import {createJobAppointment, updateJobAppointment} from "../../../store/action/appointment/appointment";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import * as React from "react";
import {none, option, Option} from "ts-option";
import DateTimePicker from "../../../hiberUiKit/src/molecules/DateTimePicker/DateTimePicker";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Toast from "../../helper/Toast";
import AppointmentStatus, {AppointmentStatusEnum} from "../../../model/appointment/AppointmentStatus";
import {RootState} from "../../../store/reducer/root/RootState";
import DateUtils from "../../../utils/DateUtils";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import JobAppointment from "../../../model/appointment/job/JobAppointment";
import JobAppointmentType from "../../../model/appointment/job/JobAppointmentType";
import User from "../../../model/user/User";
import SelectJobAppointmentAssignees from "../../lead/watchers/SelectJobAppointmentAssignees";
import {isDefined} from "../../../utils/Utils";
import AppointmentUtils, {IAppointmentDuration} from "../../../utils/AppointmentUtils";
import moment = require("moment");
import _ = require("underscore");

interface IProps {
	/**
	 * Job id.
	 */
	jobId: string;
	/**
	 * Job appointment to edit.
	 */
	appointmentToEdit?: Option<JobAppointment>
	/**
	 * Job appointment edit success callback.
	 */
	onAppointmentEditSuccess?: () => void;
	/**
	 * Partner brand Id
	 */
	partnerBrandId: Option<string>
	/**
	 * Brand Id
	 */
	brandId: Option<string>
}

interface DispatchProps {
	/**
	 * Update job appointment
	 * @param {string} jobId
	 * @param {JobAppointment} appointment
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateJobAppointment: (jobId: string, appointment: JobAppointment, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Create job appointment
	 * @param {string} jobId
	 * @param {JobAppointment} JobAppointment
	 * @param {OnSuccessData<JobAppointment>} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createJobAppointment: (jobId: string,
		appointment: JobAppointment,
		onSuccess: OnSuccessData<JobAppointment>,
		onFailure: OnFailure) => void;
}

interface IReduxProps {
	appointments: JobAppointment[],
	appointmentTypes: JobAppointmentType[]
}

interface IState {
	/**
	 * Indicating if request to server is in progress.
	 */
	isLoading: boolean;
	/**
	 * Appointment datetime.
	 */
	appointmentDateTime: moment.Moment | null;
	/**
	 * Appointment type
	 */
	appointmentType: Option<JobAppointmentType>;
	/**
	 * Assignees
	 */
	assignees: Option<string[]>
	/**
	 * Appointment duration in minutes
	 */
	appointmentDuration: Option<number>
}

type Props = IProps & DispatchProps & IReduxProps;

class JobAppointmentTab extends React.Component<Props, IState> {

	durations = AppointmentUtils.getAppointmentDurations();

	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: false,
			appointmentDateTime: null,
			appointmentType: none,
			assignees: none,
			appointmentDuration: none
		};
		this.onDateTimeChange = this.onDateTimeChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onAssigneeChange = this.onAssigneeChange.bind(this);
		this.appointmentDataInvalid = this.appointmentDataInvalid.bind(this);
		this.isDurationItemDisable = this.isDurationItemDisable.bind(this);
	}

	componentDidMount() {
		if (this.props.appointmentToEdit.isDefined) {
			this.setState({
				appointmentDateTime: this.props.appointmentToEdit.map(a => a.dateTime).orNull,
				appointmentType: this.props.appointmentToEdit.flatMap(ate => ate.type),
				assignees: this.props.appointmentToEdit.map(a => option(a.assignees)).getOrElse(none),
				appointmentDuration: this.props.appointmentToEdit.map(a => a.duration)
			});
		}
	}

	componentWillReceiveProps(nextProps: Props) {
		if (this.props.appointmentToEdit.orNull != nextProps.appointmentToEdit.orNull) {
			this.setState({
				appointmentDateTime: nextProps.appointmentToEdit.map(a => a.dateTime).orNull,
				appointmentType: nextProps.appointmentToEdit.flatMap(ate => ate.type),
				assignees: nextProps.appointmentToEdit.map(a => option(a.assignees)).getOrElse(none),
				appointmentDuration: nextProps.appointmentToEdit.map(a => a.duration)
			});
		}
	}

	render() {
		const disabledDateTimes = this.getDisabledDateTimes(this.props.appointments);
		const disabledDateTimesGroupedByDay = _.groupBy(disabledDateTimes,
			(item) => moment(item).startOf("day").format(DateUtils.DATE_FORMAT));
		const excludeDates: moment.Moment[] = [];
		const now = moment();
		Object.keys(disabledDateTimesGroupedByDay).forEach((key) => {
			//41 = 4*10+1 -> count of items with time in list [6:00, 6:15 ... 16:00]/
			if (disabledDateTimesGroupedByDay[key].length == 41) {
				return excludeDates.push(moment(key, DateUtils.DATE_FORMAT))
			}
			if (this.props.appointmentToEdit.isEmpty && moment(key, DateUtils.DATE_FORMAT).isSame(now, "day")) {
				const endTime = moment(now, "HH:mm").diff(moment().startOf("day"), "minutes");
				const timesInPast = [];
				for (let t = 6 * 60; t < endTime; t += 15) {
					const tmp = moment().startOf("day").add(t, "m");
					if (!disabledDateTimesGroupedByDay[key].filter(item => item.isSame(tmp, "minutes")).length)
						timesInPast.push(tmp);
				}
				if (timesInPast.length + disabledDateTimesGroupedByDay[key].length == 41) {
					return excludeDates.push(moment(key, DateUtils.DATE_FORMAT))
				}
			}
		});

		return (
			<div className={"c-appointment-tab"}>
				<div className={"c-appointment-tab_actions"}>
					<DateTimePicker initialDateTime={this.state.appointmentDateTime}
									onDateTimeChange={this.onDateTimeChange}
									disabledDateTimes={disabledDateTimes}
									excludeDates={excludeDates}
									endTime={"16:00"}/>
					<div className={"c-duration-dropdown"}>
						<DropDown placeholder={"Duration"}
								  items={this.durations}
								  itemToId={(item: IAppointmentDuration) => `${item.minutes}`}
								  itemToLabel={(item: IAppointmentDuration) => item.displayValue}
								  selectedItemId={this.state.appointmentDuration.map(d => `${d}`).orNull}
								  onSelect={(item: IAppointmentDuration) => this.setState(
									  {appointmentDuration: option(item.minutes)})}
								  disabled={!isDefined(this.state.appointmentDateTime)}
								  itemDisabled={this.isDurationItemDisable}/>
					</div>
					<div className={"c-appointment-type-dropdown"}>
						<DropDown placeholder={"Appointment type"}
								  items={this.props.appointmentTypes}
								  itemToId={(item: JobAppointmentType) => item.id}
								  itemToLabel={(item: JobAppointmentType) => item.getDisplayName()}
								  selectedItemId={this.state.appointmentType.map(at => at.id).orNull}
								  onSelect={(item: JobAppointmentType) => this.setState({appointmentType: option(item)})}
								  clearable
								  onClearClick={() => this.setState({appointmentType: none})}/>
					</div>
					<div style={{width: "220px", marginLeft: "10px"}}>
						<SelectJobAppointmentAssignees placeholder={"Assignees"}
													   selectedId={this.state.assignees}
													   onChanged={this.onAssigneeChange}
													   multi={true}
													   partnerBrandId={this.props.partnerBrandId}
													   brandId={this.props.brandId}/>
					</div>
					<ButtonPrimary
						label={this.props.appointmentToEdit.isDefined ? "Update job appointment" : "Add job appointment"}
						onClick={this.onSubmit}
						disabled={this.appointmentDataInvalid()}/>
				</div>
			</div>
		);
	}

	private onAssigneeChange(assignees: Option<User[]>) {
		this.setState({assignees: assignees.map(utab => utab.map(u => u.id))});
	}

	private onDateTimeChange(dateTime: moment.Moment) {
		if (!dateTime.isSame(this.state.appointmentDateTime, "minute")) {
			this.setState({appointmentDateTime: dateTime, appointmentDuration: none});
		}
	}

	private onSubmit() {
		this.setState({isLoading: true});
		const updatedDateTime = this.state.appointmentDateTime;
		const updatedAppointmentType = this.state.appointmentType;
		const assignees = this.state.assignees.getOrElse([]);
		if (this.props.appointmentToEdit.isDefined) {
			this.props.updateJobAppointment(this.props.jobId, this.props.appointmentToEdit.get.copy({
					dateTime: updatedDateTime,
					status: AppointmentStatus.fromString(AppointmentStatusEnum.Unconfirmed),
					type: updatedAppointmentType,
					assignees: assignees,
					duration: this.state.appointmentDuration.orNull
				}),
				() => {
					Toast.success("Job appointment created", "Job appointment updated");
					this.setState({isLoading: false, appointmentDateTime: null, appointmentType: none});
					this.props.onAppointmentEditSuccess();
				},
				(e) => {
					this.onFailure("Update Job Appointment", e)
				})
		}
		else {
			this.props.createJobAppointment(this.props.jobId,
				JobAppointment.create(updatedDateTime, updatedAppointmentType, assignees, this.state.appointmentDuration.orNull),
				() => {
					Toast.success("Job appointment created", "Job appointment created");
					this.setState({isLoading: false, appointmentDateTime: null, appointmentType: none});
					this.props.onAppointmentEditSuccess();
				},
				(e) => {
					this.onFailure("Create Job Appointment", e)
				})
		}
	}

	onFailure(title: string, error: any) {
		this.setState({isLoading: false});
		let err: string;
		if (error && error.response && error.response.data.status == 409) {
			if (error.response.data.exception == "UserDoesNotBelongToPartnerBrandException") {
				err = `One of the assignees does not belong to the partner brand`;
			}
			else if (error.response.data.exception == "UserDoesNotBelongToBrandException") {
				err = `One of the assignees does not belong to the brand`;
			}
			else if (error.response.data.exception == "UserBelongToPartnerBrandException") {
				err = `One of the assignees belongs to the partner brand`;
			}
			else {
				err = "Sorry, something went wrong. Try again later.";
			}
		}
		else {
			err = "Sorry, something went wrong. Try again later.";
		}
		Toast.error(err, title)
	}

	private appointmentDataInvalid() {
		return this.state.isLoading
			|| (this.state.appointmentDateTime ? !this.state.appointmentDateTime.isValid() : true)
			|| this.state.appointmentDuration.isEmpty;
	}

	private isDurationItemDisable(duration: IAppointmentDuration): boolean {
		const isNextDay = AppointmentUtils.isNextDay(option(this.state.appointmentDateTime), duration.minutes);
		const isCollisions = AppointmentUtils.isCollisionWithAppointment(duration.minutes, this.state.appointmentDateTime,
			this.props.appointments);
		return isNextDay || isCollisions;
	};

	/**
	 * Get disabled date times
	 * Example: when adt == 14:00 then disabled <06:15 - 21:45>
	 * @param {JobAppointment[]} appointments
	 * @returns {moment.Moment[]}
	 */
	private getDisabledDateTimes(appointments: JobAppointment[]): moment.Moment[] {
		const dateTimes: moment.Moment[] = [];

		appointments.filter(a => this.props.appointmentToEdit.map(appToEdit => appToEdit.id != a.id).getOrElse(true))
			.forEach(appointment => {
				const adt = appointment.dateTime;
				const startTime = moment(moment(adt).add(-(this.durations[0].minutes - 15), "m"), "HH:mm").diff(
					moment(adt).startOf("day"), "minutes");
				const endTime = moment(moment(adt).add(appointment.duration, "m"), "HH:mm").diff(moment(adt).startOf("day"),
					"minutes");
				for (let t = startTime; t < endTime; t += 15) {
					const tmp = moment(adt).startOf("day").add(t, "m");
					if (t >= 6 * 60 && t <= 16 * 60 &&
						!dateTimes.filter(item => item.isSame(tmp, "minutes")).length)
						dateTimes.push(tmp);
				}
			});

		return dateTimes
	}
}

function mapStateToProps(state: RootState, props: IProps) {
	const appointments = state.appointment.jobAppointments.getOrElse([]).filter(a => a.jobId.getOrElse("") === props.jobId);
	return ({appointments, appointmentTypes: state.appointment.jobAppointmentTypes.getOrElse([])})
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateJobAppointment: (jobId: string,
			appointment: JobAppointment,
			onSuccess: OnSuccess,
			onFailure: OnFailure) => dispatch(
			updateJobAppointment(jobId, appointment, onSuccess, onFailure)),
		createJobAppointment: (jobId: string,
			appointment: JobAppointment,
			onSuccess: OnSuccessData<JobAppointment>,
			onFailure: OnFailure) => dispatch(createJobAppointment(jobId, appointment, onSuccess, onFailure))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobAppointmentTab)